import { removeNamespace } from '@piri/vue-utils';

import moduleName from './moduleName';
import getterTypes from './types/getterTypes';

const getterTypesInModule = removeNamespace(moduleName, getterTypes);

const sites = state => state.sites;
const site = state => state.site;
const selectedId = state => state.selectedId;
const selected = state => state.selected;

export default {
  [getterTypesInModule.SITES]: sites,
  [getterTypesInModule.SITE]: site,
  [getterTypesInModule.SELECTED_ID]: selectedId,
  [getterTypesInModule.SELECTED]: selected,
};
